/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConfirmarResetPasswordDto } from '../../models/confirmar-reset-password-dto';

export interface UsuariosControllerConfirmarResetPassword$Params {
  uuidResetPassword: string;
      body: ConfirmarResetPasswordDto
}

export function usuariosControllerConfirmarResetPassword(http: HttpClient, rootUrl: string, params: UsuariosControllerConfirmarResetPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, usuariosControllerConfirmarResetPassword.PATH, 'post');
  if (params) {
    rb.path('uuidResetPassword', params.uuidResetPassword, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

usuariosControllerConfirmarResetPassword.PATH = '/api/usuarios/confirmar-reset-password/{uuidResetPassword}';
